/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Topic_PuttingInputs */

const en_practice_topic_putting = /** @type {(inputs: Practice_Topic_PuttingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Putting`)
};

const es_practice_topic_putting = /** @type {(inputs: Practice_Topic_PuttingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Putting`)
};

const de_practice_topic_putting = /** @type {(inputs: Practice_Topic_PuttingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Putten`)
};

const zh_practice_topic_putting = /** @type {(inputs: Practice_Topic_PuttingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推杆`)
};

const ar_practice_topic_putting = /** @type {(inputs: Practice_Topic_PuttingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الباتينغ`)
};

const fr_practice_topic_putting = /** @type {(inputs: Practice_Topic_PuttingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Putting`)
};

const vi_practice_topic_putting = /** @type {(inputs: Practice_Topic_PuttingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Putting`)
};

const sw_practice_topic_putting = /** @type {(inputs: Practice_Topic_PuttingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Putting`)
};

const th_practice_topic_putting = /** @type {(inputs: Practice_Topic_PuttingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`พัตต์`)
};

const bs_practice_topic_putting = /** @type {(inputs: Practice_Topic_PuttingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Putting`)
};

const ja_practice_topic_putting = /** @type {(inputs: Practice_Topic_PuttingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パッティング`)
};

const ko_practice_topic_putting = /** @type {(inputs: Practice_Topic_PuttingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`퍼팅`)
};

const pt_practice_topic_putting = /** @type {(inputs: Practice_Topic_PuttingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Putting`)
};

const it_practice_topic_putting = /** @type {(inputs: Practice_Topic_PuttingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Putting`)
};

const sv_practice_topic_putting = /** @type {(inputs: Practice_Topic_PuttingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puttning`)
};

const nl_practice_topic_putting = /** @type {(inputs: Practice_Topic_PuttingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Putten`)
};

const da_practice_topic_putting = /** @type {(inputs: Practice_Topic_PuttingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Putting`)
};

const nb_practice_topic_putting = /** @type {(inputs: Practice_Topic_PuttingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Putting`)
};

const fi_practice_topic_putting = /** @type {(inputs: Practice_Topic_PuttingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puttaus`)
};

const pl_practice_topic_putting = /** @type {(inputs: Practice_Topic_PuttingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Putting`)
};

const ru_practice_topic_putting = /** @type {(inputs: Practice_Topic_PuttingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Паттинг`)
};

const tr_practice_topic_putting = /** @type {(inputs: Practice_Topic_PuttingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Putt`)
};

const hi_practice_topic_putting = /** @type {(inputs: Practice_Topic_PuttingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पुटिंग`)
};

const id_practice_topic_putting = /** @type {(inputs: Practice_Topic_PuttingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Putting`)
};

const ms_practice_topic_putting = /** @type {(inputs: Practice_Topic_PuttingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Putting`)
};

const cs_practice_topic_putting = /** @type {(inputs: Practice_Topic_PuttingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Putting`)
};

const el_practice_topic_putting = /** @type {(inputs: Practice_Topic_PuttingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Πατ`)
};

const he_practice_topic_putting = /** @type {(inputs: Practice_Topic_PuttingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פאטינג`)
};

const af_practice_topic_putting = /** @type {(inputs: Practice_Topic_PuttingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Putt`)
};

const hu_practice_topic_putting = /** @type {(inputs: Practice_Topic_PuttingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puttolás`)
};

/**
* | output |
* | --- |
* | "Putting" |
*
* @param {Practice_Topic_PuttingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const practice_topic_putting = /** @type {((inputs?: Practice_Topic_PuttingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Topic_PuttingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_practice_topic_putting(inputs)
	if (locale === "de") return de_practice_topic_putting(inputs)
	if (locale === "zh") return zh_practice_topic_putting(inputs)
	if (locale === "ar") return ar_practice_topic_putting(inputs)
	if (locale === "fr") return fr_practice_topic_putting(inputs)
	if (locale === "vi") return vi_practice_topic_putting(inputs)
	if (locale === "sw") return sw_practice_topic_putting(inputs)
	if (locale === "th") return th_practice_topic_putting(inputs)
	if (locale === "bs") return bs_practice_topic_putting(inputs)
	if (locale === "ja") return ja_practice_topic_putting(inputs)
	if (locale === "ko") return ko_practice_topic_putting(inputs)
	if (locale === "pt") return pt_practice_topic_putting(inputs)
	if (locale === "it") return it_practice_topic_putting(inputs)
	if (locale === "sv") return sv_practice_topic_putting(inputs)
	if (locale === "nl") return nl_practice_topic_putting(inputs)
	if (locale === "da") return da_practice_topic_putting(inputs)
	if (locale === "nb") return nb_practice_topic_putting(inputs)
	if (locale === "fi") return fi_practice_topic_putting(inputs)
	if (locale === "pl") return pl_practice_topic_putting(inputs)
	if (locale === "ru") return ru_practice_topic_putting(inputs)
	if (locale === "tr") return tr_practice_topic_putting(inputs)
	if (locale === "hi") return hi_practice_topic_putting(inputs)
	if (locale === "id") return id_practice_topic_putting(inputs)
	if (locale === "ms") return ms_practice_topic_putting(inputs)
	if (locale === "cs") return cs_practice_topic_putting(inputs)
	if (locale === "el") return el_practice_topic_putting(inputs)
	if (locale === "he") return he_practice_topic_putting(inputs)
	if (locale === "af") return af_practice_topic_putting(inputs)
	if (locale === "hu") return hu_practice_topic_putting(inputs)
	return en_practice_topic_putting(inputs)
});